import get from 'lodash/get'
import {
  UPDATE_HIGHLIGHTED_ITEMS,
  UPDATE_SEARCH_QUERY,
  UPDATE_FOCUSED_ITEM_ID,
  UPDATE_SELECTED_CATEGORY,
  TOGGLE_SHOW_CLOSED_TABS,
  SET_SHOW_ONLY_ACTIVE_ATTENDANT,
  RESET_ATTENDANT_VIEW,
  CLEAR_SEARCH,
} from "../actions/search"

const defaultState = {
  showClosedTabs: false,
  showOnlyActiveAttendantOrders: true,
}

const reducer = (state = defaultState, action) => {

  switch(action.type) {
    case UPDATE_HIGHLIGHTED_ITEMS:
      const searchParams = get(action.payload, 'searchParams', {})
      const hasQuickSearchResults = !!(get(searchParams, 'highlightedIds', []).length)

      return {
        ...state,
        ...searchParams,
        hasQuickSearchResults,
      }

    case UPDATE_SEARCH_QUERY:

      const searchQuery = get(action.payload, 'searchQuery', '')
      return {
        ...state,
        searchQuery,
      }

    case UPDATE_FOCUSED_ITEM_ID:

        const focusedItemId = get(action.payload, 'focusedItemId', undefined)
        return {
          ...state,
          focusedItemId,
        }

    case UPDATE_SELECTED_CATEGORY:

        const selectedCategory = get(action.payload, 'selectedCategory')
        return {
          ...state,
          selectedCategory,
        }

    case TOGGLE_SHOW_CLOSED_TABS:

        return {
          ...state,
          showClosedTabs: !state.showClosedTabs
        }

    case SET_SHOW_ONLY_ACTIVE_ATTENDANT:

        return {
          ...state,
          showOnlyActiveAttendantOrders: action.payload
        }

    case RESET_ATTENDANT_VIEW:

        return {
          ...state,
          query: '',
          highlightedIds: [],
          focusedItemId: undefined,
          hasQuickSearchResults: false,
          showClosedTabs: false,
          showOnlyActiveAttendantOrders: true
        }

    case CLEAR_SEARCH:

    return {
      ...state,
      query: '',
      highlightedIds: [],
      focusedItemId: undefined,
      hasQuickSearchResults: false,
    }

    default:
      return state

  }
}

export default reducer
